import imageCompression from 'browser-image-compression'

export const saveJson = (() => {
  return (data: any, fileName: string) => {
    let a = document.createElement('a')
    document.body.appendChild(a)
    a.style.display = 'none'
    let json = JSON.stringify(data)
    let blob = new Blob([json], { type: 'octet/stream' })
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = fileName
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }
})()

export const downloadBlob = (blob: Blob, name = 'file.txt') => {
  const data = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = data
  link.download = name

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  )

  setTimeout(() => {
    window.URL.revokeObjectURL(data)
    link.remove()
  }, 100)
}

export const getFileExtension = (filename: string) => {
  const parts = filename.split('.')
  return parts[parts.length - 1]
}

export const getFileName = (filename: string) => {
  return filename.replace(/\.[^/.]+$/, '')
}

export const blobToFile = (theBlob: Blob, fileName: string): File => {
  return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
}

export const base64ToBlob = (base64Image: string) => {
  const parts = base64Image.split(';base64,')
  const imageType = parts[0].split(':')[1]
  const decodedData = window.atob(parts[1])
  const uInt8Array = new Uint8Array(decodedData.length)

  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i)
  }

  return new Blob([uInt8Array], { type: imageType })
}

export class MyFile {
  public readonly file: File

  constructor(file: File) {
    this.file = file
  }

  public isImage() {
    return !!this.file.type.match('image.*')
  }

  public isVideo() {
    return !!this.file.type.match('video.*')
  }

  public isAudio() {
    return !!this.file.type.match('audio.*')
  }

  public async compress({
    initialQuality = 0.25,
    maxWidthOrHeight,
  }: {
    initialQuality?: number
    maxWidthOrHeight?: number
  } = {}) {
    if (this.isImage()) {
      const options = { initialQuality, maxWidthOrHeight }
      return imageCompression(this.file, options)
    }

    return this.file
  }

  public getFilename() {
    return `${getFileName(this.file.name)}.${getFileExtension(this.file.name)}`
  }
}
